import config from 'src/config'

import { io } from 'socket.io-client'
import { createSocketRequests } from './socketRequests'
export type { FetchProps as fetchProps, SocketResponse as ioFetchResponse } from './socketRequests'

const socket = io(config.api_server, {
  reconnectionDelayMax: 1000,
})

export type tSocket = typeof socket

export const { fetch, authenticate, clearAuthentication } = createSocketRequests(socket)

export default socket
